import Sound from "~/ui/sound"
import { debug } from "../utils"

Sound.setCategory("Playback")

const loadSound = (name: string) => {
  const sound = new Sound(name, Sound.MAIN_BUNDLE, (error) => {
    if (error) {
      // console.error("failed to load the sound", error)
      return
    }
    const duration = Math.floor(sound.getDuration() * 100) / 100
    debug(`${name} loaded, duration: ${duration}s, channels: ${sound.getNumberOfChannels()}`)
  })
  return sound
}

export const newMessageSound = loadSound("pre_sms.mp3")
export const messageSentSound = loadSound("message_sent.mp3")
